import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import EligibilityChecker from "../components/CheckEligibility";
import { getMasterHealthPlan } from "../../../actions/Master";
import { ApplicationState } from "../../../redux/ApplicationState";
import { getListResult } from "../../../utils";
import { EligibilityCheck } from "../../../models/Patient";
import { checkEligibility } from "../../../actions/Patient";
import { EligibilityCheckActionDispatchTypes } from "../../../constants/Patient";
import { UserPageTrack } from "../../../models/User";
import { postUserPageTrack } from "../../../actions/UserAction";

const mapStateToProps = ({
  healthPlanState,
  checkEligibilityState,
}: ApplicationState) => ({
  healthPlanState: getListResult(healthPlanState.response),
  checkEligibilityState: checkEligibilityState.response,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    getMasterHealthPlan: () => {
      dispatch(getMasterHealthPlan());
    },
    checkEligibility: (payload: EligibilityCheck) => {
      dispatch(checkEligibility(payload));
    },
    resetCheckEligibility: () => {
      dispatch({
        type: EligibilityCheckActionDispatchTypes.ELIGIBILITY_CHECK_RESET,
      });
    },
    postUserPageTrack: (payload: UserPageTrack) => {
      dispatch(postUserPageTrack(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EligibilityChecker);
